import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Strings from "../../../Config/Strings";
import { getRoleAPI } from "../../../Store/Action/rolePermissionAction";
import Colors from "../../../theme/Colors";
import RolePermissionTable from "./Controls/RolePermissionTable";

const RolePermissionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [role, setRole] = useState([]);

  const { userData } = useSelector((state) => state.user);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Masters" },
      { key: "2", href: "/userList", text: Strings.rolePermission },
    ]);
  }, []);

  useEffect(() => {
    dispatch(
      getRoleAPI({}, (result) => {
        setRole(result);
      })
    );
  }, [dispatch]);

  const onAddRolePermission = useCallback(
    (roles) => {
      navigate("/rolePermissionModuleList", {
        state: { roles },
      });
    },
    [navigate]
  );

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />

      <div style={topContainerStyle}>
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.user_first_name}`}
          isDashboard={true}
        />
        <BreadcrumbsComponent breadcrumbs={breadcrumbs} />

        <div style={tableContainerStyle}>
          <RolePermissionTable
            role={role}
            onAddRolePermissions={onAddRolePermission}
          />
        </div>
      </div>
    </div>
  );
};

const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const topContainerStyle = {
  backgroundColor: Colors.lightBlue,
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

const tableContainerStyle = {
  width: "95%",
  height: "80%",
  marginLeft: "24px",
  marginTop: '15px',
  backgroundColor: Colors.white
};

export default RolePermissionList;
